export const fr: Record<string, string> = {
  // ── Resources (res.*) ──
  'res.allTypes': 'Tous les types',
  'res.allFunctions': 'Toutes les fonctions',
  'res.deleting': 'Suppression…',
  'res.deleteCount': 'Supprimer ({n})',
  'res.addResource': 'Ajouter une ressource',
  'res.emptyTitle': 'Aucune ressource trouvée',
  'res.emptyDescAdmin': 'Importez un CSV ou ajoutez des ressources manuellement pour commencer.',
  'res.emptyDescUser': 'Aucune ressource n’a encore été ajoutée.',
  'res.selectAll': 'Tout sélectionner',
  'res.colTitle': 'Titre',
  'res.colType': 'Type',
  'res.colFunction': 'Fonction',
  'res.colDescription': 'Description',
  'res.editResource': 'Modifier la ressource',
  'res.labelTitle': 'Titre *',
  'res.labelType': 'Type *',
  'res.labelFunction': 'Fonction *',
  'res.functionPlaceholder': 'ex. : Prestation de services, RH, TI',
  'res.labelDescription': 'Description',
  'res.create': 'Créer',
  'res.confirmDelete': 'Supprimer « {title} » ?',
  'res.uploadResult': '{n} ressources importées avec {e} erreurs',
  'res.confirmBulkOne': 'Supprimer 1 ressource sélectionnée ? Cette action est irréversible.',
  'res.confirmBulkMany': 'Supprimer {n} ressources sélectionnées ? Cette action est irréversible.',
  'res.uploadModalTitle': 'Importer un CSV de ressources',

  // ── Capabilities (cap.*) ──
  'cap.allNatures': 'Toutes les natures',
  'cap.allDomains': 'Tous les domaines',
  'cap.deleting': 'Suppression…',
  'cap.deleteCount': 'Supprimer ({n})',
  'cap.addCapability': 'Ajouter une capacité',
  'cap.emptyTitle': 'Aucune capacité trouvée',
  'cap.emptyDescAdmin': 'Importez un CSV ou ajoutez des capacités manuellement pour commencer.',
  'cap.emptyDescUser': 'Aucune capacité n’a encore été ajoutée.',
  'cap.selectAllIn': 'Tout sélectionner dans {domain}',
  'cap.colTitle': 'Titre',
  'cap.colNature': 'Nature',
  'cap.colDescription': 'Description',
  'cap.editCapability': 'Modifier la capacité',
  'cap.labelTitle': 'Titre *',
  'cap.labelNature': 'Nature *',
  'cap.labelDomain': 'Domaine *',
  'cap.labelDescription': 'Description',
  'cap.create': 'Créer',
  'cap.confirmDelete': 'Supprimer « {title} » ?',
  'cap.uploadResult': '{n} capacités importées avec {e} erreurs',
  'cap.confirmBulkOne': 'Supprimer 1 capacité sélectionnée ? Cette action est irréversible.',
  'cap.confirmBulkMany': 'Supprimer {n} capacités sélectionnées ? Cette action est irréversible.',
  'cap.uploadModalTitle': 'Importer un CSV de capacités',

  // ── Outcomes (out.*) ──
  'out.allMotivatedBy': 'Tous (motivé par)',
  'out.addOutcome': 'Ajouter un résultat',
  'out.emptyTitle': 'Aucun résultat trouvé',
  'out.emptyDescAdmin': 'Importez un CSV ou ajoutez des résultats manuellement pour commencer.',
  'out.emptyDescUser': 'Aucun résultat n’a encore été ajouté.',
  'out.uncategorized': 'Non catégorisé',
  'out.colTitle': 'Titre',
  'out.colMotivatedFor': 'Motivé pour',
  'out.colTags': 'Étiquettes',
  'out.colDescription': 'Description',
  'out.editOutcome': 'Modifier le résultat',
  'out.labelTitle': 'Titre *',
  'out.labelMotivatedBy': 'Motivé par',
  'out.labelMotivatedFor': 'Motivé pour',
  'out.labelTags': 'Étiquettes',
  'out.tagPlaceholder': 'Saisissez puis appuyez sur Entrée…',
  'out.labelDescription': 'Description',
  'out.create': 'Créer',
  'out.confirmDelete': 'Supprimer « {title} » ?',
  'out.uploadResult': '{n} résultats importés avec {e} erreurs',
  'out.uploadModalTitle': 'Importer un CSV de résultats',

  // ── FileUpload (file.*) ──
  'file.dropHint': 'Déposez un fichier CSV ici ou cliquez pour le sélectionner',
  'file.expectedHeaders': 'En-têtes attendus : {headers}',
  'file.missingHeaders': 'En-têtes requis manquants : {headers}',
  'file.notCsv': 'Veuillez importer un fichier CSV',
  'file.preview': 'Aperçu ({n} lignes) :',
  'file.moreRows': '… et {n} lignes supplémentaires',
  'file.uploadRows': 'Importer {n} lignes',
};

export const en: Record<string, string> = {
  // ── Resources (res.*) ──
  'res.allTypes': 'All Types',
  'res.allFunctions': 'All Functions',
  'res.deleting': 'Deleting...',
  'res.deleteCount': 'Delete ({n})',
  'res.addResource': 'Add Resource',
  'res.emptyTitle': 'No resources found',
  'res.emptyDescAdmin': 'Upload a CSV or add resources manually to get started.',
  'res.emptyDescUser': 'No resources have been added yet.',
  'res.selectAll': 'Select all',
  'res.colTitle': 'Title',
  'res.colType': 'Type',
  'res.colFunction': 'Function',
  'res.colDescription': 'Description',
  'res.editResource': 'Edit Resource',
  'res.labelTitle': 'Title *',
  'res.labelType': 'Type *',
  'res.labelFunction': 'Function *',
  'res.functionPlaceholder': 'e.g., Service Delivery, HR, IT',
  'res.labelDescription': 'Description',
  'res.create': 'Create',
  'res.confirmDelete': 'Delete "{title}"?',
  'res.uploadResult': 'Uploaded {n} resources with {e} errors',
  'res.confirmBulkOne': 'Delete 1 selected resource? This action cannot be undone.',
  'res.confirmBulkMany': 'Delete {n} selected resources? This action cannot be undone.',
  'res.uploadModalTitle': 'Upload Resources CSV',

  // ── Capabilities (cap.*) ──
  'cap.allNatures': 'All Natures',
  'cap.allDomains': 'All Domains',
  'cap.deleting': 'Deleting...',
  'cap.deleteCount': 'Delete ({n})',
  'cap.addCapability': 'Add Capability',
  'cap.emptyTitle': 'No capabilities found',
  'cap.emptyDescAdmin': 'Upload a CSV or add capabilities manually to get started.',
  'cap.emptyDescUser': 'No capabilities have been added yet.',
  'cap.selectAllIn': 'Select all in {domain}',
  'cap.colTitle': 'Title',
  'cap.colNature': 'Nature',
  'cap.colDescription': 'Description',
  'cap.editCapability': 'Edit Capability',
  'cap.labelTitle': 'Title *',
  'cap.labelNature': 'Nature *',
  'cap.labelDomain': 'Domain *',
  'cap.labelDescription': 'Description',
  'cap.create': 'Create',
  'cap.confirmDelete': 'Delete "{title}"?',
  'cap.uploadResult': 'Uploaded {n} capabilities with {e} errors',
  'cap.confirmBulkOne': 'Delete 1 selected capability? This action cannot be undone.',
  'cap.confirmBulkMany': 'Delete {n} selected capabilities? This action cannot be undone.',
  'cap.uploadModalTitle': 'Upload Capabilities CSV',

  // ── Outcomes (out.*) ──
  'out.allMotivatedBy': 'All (Motivated By)',
  'out.addOutcome': 'Add Outcome',
  'out.emptyTitle': 'No outcomes found',
  'out.emptyDescAdmin': 'Upload a CSV or add outcomes manually to get started.',
  'out.emptyDescUser': 'No outcomes have been added yet.',
  'out.uncategorized': 'Uncategorized',
  'out.colTitle': 'Title',
  'out.colMotivatedFor': 'Motivated For',
  'out.colTags': 'Tags',
  'out.colDescription': 'Description',
  'out.editOutcome': 'Edit Outcome',
  'out.labelTitle': 'Title *',
  'out.labelMotivatedBy': 'Motivated By',
  'out.labelMotivatedFor': 'Motivated For',
  'out.labelTags': 'Tags',
  'out.tagPlaceholder': 'Type and press Enter...',
  'out.labelDescription': 'Description',
  'out.create': 'Create',
  'out.confirmDelete': 'Delete "{title}"?',
  'out.uploadResult': 'Uploaded {n} outcomes with {e} errors',
  'out.uploadModalTitle': 'Upload Outcomes CSV',

  // ── FileUpload (file.*) ──
  'file.dropHint': 'Drop a CSV file here or click to select',
  'file.expectedHeaders': 'Expected headers: {headers}',
  'file.missingHeaders': 'Missing required headers: {headers}',
  'file.notCsv': 'Please upload a CSV file',
  'file.preview': 'Preview ({n} rows):',
  'file.moreRows': '... and {n} more rows',
  'file.uploadRows': 'Upload {n} rows',
};
